import { ProgressBarWebElementBase } from './ProgressBarWebElementBase';

/**
 * The component WebElement for [oj-c-progress-bar](../../jsdocs/oj-c.ProgressBar.html).
 * Do not instantiate this class directly, instead, use
 * [findProgressBar](../functions/findProgressBar.html).
 */
export class ProgressBarWebElement extends ProgressBarWebElementBase {
  // Put overrides here
}
